import { createFragmentContainer, graphql } from 'react-relay';

import redraft from 'redraft';

import renderers from './renderers';

function BlogContent({ post }) {
  const data = JSON.parse(post.contentJson);

  return redraft(data, renderers, {
    cleanup: {
      after: 'all',
      types: 'all',
      trim: true,
      split: true,
    },
  });
}

export default createFragmentContainer(BlogContent, {
  post: graphql`
    fragment BlogContent_post on BlogPost {
      contentJson
    }
  `,
});
